const TOKEN = 'X-Auth-PayQin-Web-Token';

export const setToken = value => localStorage.setItem(TOKEN, value);
export const getToken = () => localStorage.getItem(TOKEN);
export const removeToken = () => localStorage.removeItem(TOKEN);

export const sessionSetToken = value => window.sessionStorage.setItem(TOKEN, value);
export const sessionGetToken = () => window.sessionStorage.getItem(TOKEN);
export const sessionRemoveToken = () => window.sessionStorage.removeItem(TOKEN);
